<div class="flex-1 min-h-0 overflow-y-auto">
  @if (flujoEditando()) {
    <app-mica-chat-flujo-editor [flujo]="flujoEditando()!" (cerrar)="cerrarEditor()" />
  } @else {
    <div class="max-w-4xl mx-auto p-4 sm:p-6 space-y-6">
      <div class="flex items-center justify-between">
        <div>
          <h2 class="text-lg font-semibold text-slate-800">Flujos de automatización</h2>
          <p class="text-sm text-slate-500">
            Configura respuestas automáticas y menús interactivos para WhatsApp.
          </p>
        </div>
        <button
          class="rounded-lg bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700 transition-colors"
          (click)="mostrarCrear.set(true)"
        >
          + Nuevo flujo
        </button>
      </div>

      @if (mostrarCrear()) {
        <div class="rounded-xl border border-sky-200 bg-sky-50 p-5">
          <h3 class="text-sm font-semibold text-sky-800 mb-3">Crear nuevo flujo</h3>
          <div class="flex flex-col sm:flex-row gap-3">
            <input
              type="text"
              class="flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
              placeholder="Nombre del flujo"
              [ngModel]="nuevoNombre()"
              (ngModelChange)="nuevoNombre.set($event)"
              (keyup.enter)="crearFlujo()"
            />
            <input
              type="text"
              class="flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
              placeholder="Descripción (opcional)"
              [ngModel]="nuevaDescripcion()"
              (ngModelChange)="nuevaDescripcion.set($event)"
              (keyup.enter)="crearFlujo()"
            />
            <button
              class="rounded-lg bg-sky-600 px-4 py-2 text-sm text-white"
              (click)="crearFlujo()"
            >
              Crear
            </button>
            <button
              class="rounded-lg border border-slate-300 px-4 py-2 text-sm text-slate-600"
              (click)="mostrarCrear.set(false)"
            >
              Cancelar
            </button>
          </div>
        </div>
      }

      @if (cargando()) {
        <div class="flex justify-center py-12 text-slate-400">
          <i class="bi bi-hourglass-split text-2xl animate-spin"></i>
        </div>
      } @else if (flujos().length === 0) {
        <div class="flex flex-col items-center gap-3 py-12 text-slate-400">
          <i class="bi bi-diagram-3 text-4xl"></i>
          <p class="text-sm">No hay flujos configurados para este teléfono.</p>
          <p class="text-xs">Crea uno para empezar a automatizar respuestas.</p>
        </div>
      } @else {
        <div class="space-y-3">
          @for (flujo of flujos(); track flujo.id) {
            <div class="rounded-xl border border-slate-200 bg-white shadow-sm p-5">
              <div class="flex items-start justify-between gap-4">
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 flex-wrap">
                    <span class="font-semibold text-slate-800">{{ flujo.nombre }}</span>
                    <span
                      class="text-[10px] px-2 py-0.5 rounded-full font-medium"
                      [class.bg-emerald-50]="flujo.activo"
                      [class.text-emerald-700]="flujo.activo"
                      [class.bg-slate-100]="!flujo.activo"
                      [class.text-slate-500]="!flujo.activo"
                    >
                      {{ flujo.activo ? 'Activo' : 'Inactivo' }}
                    </span>
                    <span class="text-xs text-slate-400">{{ flujo.pasos?.length || 0 }} pasos</span>
                  </div>
                  @if (flujo.descripcion) {
                    <p class="text-sm text-slate-500 mt-1">{{ flujo.descripcion }}</p>
                  }
                </div>
                <div class="flex items-center gap-2 shrink-0">
                  <label class="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      class="sr-only peer"
                      [checked]="flujo.activo"
                      (change)="toggleActivo(flujo)"
                    />
                    <div
                      class="w-9 h-5 rounded-full bg-slate-200 peer-checked:bg-emerald-500 relative after:absolute after:top-0.5 after:inset-s-0.5 after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-3.5"
                    ></div>
                  </label>
                  <button
                    class="rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-600 hover:bg-slate-50"
                    (click)="abrirEditor(flujo)"
                  >
                    <i class="bi bi-pencil mr-1"></i>Editar
                  </button>
                  <button
                    class="rounded-lg border border-red-200 px-3 py-1.5 text-xs text-red-600 hover:bg-red-50"
                    (click)="eliminarFlujo(flujo)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
